import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { fromEvent, Subscription } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { NamModalService } from 'src/app/servizi/nam/nam-modal.service';
import { map, take, tap } from 'rxjs/operators';
import { NamSelectedObjectService } from 'src/app/servizi/nam/nam-object-selected.service';
import { TemplateService } from 'src/app/servizi/nam/template.service';
import { NamApiResponse } from '../../model/nam-api-response.interface';
import { NamObjectTemplate, NamObjectTemplates } from '../../model/nam-object-template.interface';

@Component({
  selector: 'app-templates-container',
  templateUrl: './templates-container.component.html',
  styleUrls: ['./templates-container.component.scss'],
})
export class TemplatesContainerComponent implements AfterViewInit, OnDestroy {
  templates$: Observable<NamApiResponse<NamObjectTemplates>>;

  paginatedTemplates: NamObjectTemplates = [];
  paginatedListDisplay: NamObjectTemplates = [];
  allTemplates: NamObjectTemplates = [];

  templateImage$;
  previewObjectTemplate$: Observable<NamObjectTemplate>;
  hasPreviewObjectTemplateSelected$: Observable<boolean>;

  namTemplateSubscription: Subscription;

  templateFilter: string = "";

  @ViewChild('insertTemplateButton') insertTemplateB: ElementRef<HTMLButtonElement>;

  constructor(
    private namSelectedObjectService: NamSelectedObjectService,
    private activeModal: NgbActiveModal,
    private templateService: TemplateService
  ) {
    this.templates$ = namSelectedObjectService.getTemplatesForSelectedObject();
    this.templates$.subscribe(data => {
      this.allTemplates = data.data; 
      this.paginatedTemplates = JSON.parse(JSON.stringify(this.allTemplates));
      this.getListPagination(this.paginatedTemplates);
    })
    this.templateImage$ = namSelectedObjectService.getImageForSelectedTemplate();
    this.previewObjectTemplate$ = namSelectedObjectService.previewSelectedObjectTemplate$;
    this.hasPreviewObjectTemplateSelected$ = namSelectedObjectService.previewSelectedObjectTemplate$.pipe(
      map((t) => !!t?.name && !!t?.collection)
    );
  }
  ngAfterViewInit(): void {
    this.namSelectedObjectService.clickStream$ = fromEvent(
      this.insertTemplateB.nativeElement,'click'
    ) as Observable<PointerEvent>;
    
    // should this be here ?
    this.namTemplateSubscription = this.namSelectedObjectService
      .getObjectTemplateToInsert()
      .subscribe((template: NamObjectTemplate) => {
        this.templateService.addTemplateToMap(template);
        this.activeModal.close();
      });
  }

  ngOnDestroy() {
    this.namTemplateSubscription.unsubscribe();
  }

  handleSelectedObjectTemplate(item: NamObjectTemplate) {
    // console.log('handleSelectedObjectTemplate', item);
    this.namSelectedObjectService.previewSelectedObjectTemplate = item;
  }

  getListPagination(templates) {
    // console.log('getListPagination', templates);
    setTimeout(() => {
      this.paginatedListDisplay = [...templates];
    });
  }

  filterList(){
    const filter = this.templateFilter;
    const filteredList = this.allTemplates.filter(element => {
      return element.name.toUpperCase().includes(filter.toUpperCase());
    });

    //Create a deep copy
    this.paginatedTemplates = JSON.parse(JSON.stringify(filteredList));
    console.log(this.paginatedTemplates);
    
  }
}
